import { CommonModule } from '@angular/common';
import { CguComponent } from './cgu/cgu.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CookieComponent } from './cookie/cookie.component';
import { SharedModule } from '@app/shared/shared.module';
import { CguCookieContainerComponent } from './cgu-cookie-container/cgu-cookie-container.component';



@NgModule({
    declarations: [
        CguComponent,
        CookieComponent,
        CguCookieContainerComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
    ],
    exports: [
        CguCookieContainerComponent
    ]
})
export class SmashCguCookiesModule { }
